// 过滤空格
export default {
  mounted: (el: HTMLElement) => {
    const inputEl = el.getElementsByTagName('input')[0] || el.getElementsByTagName('textarea')[0]
    if (!inputEl) return
    inputEl.addEventListener('input', () => {
      const newValue = inputEl.value.replace(/\s+/g, '')
      if (newValue !== inputEl.value) {
        inputEl.value = newValue
        inputEl.dispatchEvent(new Event('input'))
      }
    })
  },
}
